module.exports = __webpack_public_path__ + "media/images/redesign-images/how-it-works/icons/icon-how-screens-d5377b73b59fffe526cac9ab9bb6bcd1.svg";